let menu_is_open = false;

// Función para manejar la apertura y el cierre del menú
function toggleMenu() {
  var primaryMenu = document.getElementById('primary-menu');
  var iconOpen = document.querySelector('.menu-icon-open');
  var iconClose = document.querySelector('.menu-icon-close');
  var xHeader = document.querySelector('.header');
  var menuOverlay = document.getElementById('menu-overlay');
  var announcementBar = document.querySelector('.announcement-bar');
  var mainheader = document.querySelector(".shopify-section--header");
  var initialItem = document.querySelector(".initialopen");
  var elementWithInitialOpen = document.querySelector('.initialopen');
  var parentInitialOpen = elementWithInitialOpen.parentNode;

  menu_is_open = menu_is_open ? false : true;
  document.body.classList.toggle('no-scroll');
  primaryMenu.classList.toggle('md:hidden');
  iconOpen.classList.toggle('hidden');
  iconClose.classList.toggle('hidden');
  xHeader.classList.toggle('menu-desktop-open');
  menuOverlay.classList.toggle('show-overlay');
  announcementBar.classList.toggle('hidden');
  mainheader.classList.add("header-fixed");
  if(!menu_is_open) {
    mainheader.classList.remove("header-fixed");
  } else {
    if (initialItem) {
      setTimeout(function() {
        initialItem.setAttribute("open", "");
        initialItem.setAttribute("aria-expanded", "true");
        parentInitialOpen.classList.add("stay-hover");
    }, 250);
    }
  }
}

// Agregar evento al hacer clic en 'menu-toggle'
document.getElementById('menu-toggle').addEventListener('click', toggleMenu);

// Agregar evento al hacer clic en 'menu-overlay' para cerrar el menú
document.getElementById('menu-overlay').addEventListener('click', function () {
  var primaryMenu = document.getElementById('primary-menu');
  
  // Cerrar el menú solo si está abierto
  if (!primaryMenu.classList.contains('md:hidden')) {
    toggleMenu();
  }
});


let lastScrollTop = 0;
let header_start_scroll = 148;
let first_up = false;

  window.addEventListener("scroll", () => {
      let st = window.pageYOffset || document.documentElement.scrollTop;
      const header = document.querySelector(".shopify-section--header");
      const inside_header = document.querySelector(".header");

      if (!menu_is_open) {

      if (st > lastScrollTop) {
          // Scrolling down, hide the header
          if(st > header_start_scroll) {
            header.classList.remove("header-fixed");
            header.classList.remove("header-on-top");
            inside_header.classList.remove("is-solid");
            if(first_up){
              header.classList.add("header-un-fixed");
            }
          }
          header.classList.add("scroll-down");
          header.classList.remove("scroll-up");
      } else {
          // Scrolling up, show the header
          header.classList.add("scroll-up");
          header.classList.remove("scroll-down");
          header.classList.add("header-fixed");
          inside_header.classList.add("is-solid");
          header.classList.remove("header-on-top");
          header.classList.remove("header-un-fixed");
          if (st < header_start_scroll) {
            header.classList.add("header-on-top");
            header.classList.remove("header-fixed");
            inside_header.classList.remove("is-solid");
            first_up = false;
          }
          if (st > header_start_scroll) {
            first_up = true;
          }
      }
      lastScrollTop = st <= 41 ? 41 : st;

    }
  });
